import CloseIcon from '@mui/icons-material/Close';
import { Button, ButtonBase, Drawer, Radio, Stack, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';
type FilterAppointmentsDrawerProps = {
  open: boolean;
  onClose: () => void;
  selectedDays: string[];
  timeOfDay: string;
  handleApply: (days: string[], timeOfDay: string) => void;
};
const FilterAppointmentsDrawer = ({
  open,
  onClose,
  selectedDays = [],
  timeOfDay,
  handleApply
}: FilterAppointmentsDrawerProps) => {
  const {
    t
  } = useTranslation('index');
  const [tempSelectedDays, setTempSelectedDays] = useState<string[]>(selectedDays);
  const [tempTimeOfDay, setTempTimeOfDay] = useState<string>(timeOfDay);
  const days = [t('monday'), t('tuesday'), t('wednesday'), t('thursday'), t('friday'), t('saturday')];
  const handleDayClick = (day: string) => {
    if (tempSelectedDays.includes(day)) {
      setTempSelectedDays(tempSelectedDays.filter(selectedDay => selectedDay !== day));
    } else {
      setTempSelectedDays([...tempSelectedDays, day]);
    }
  };
  return <>
			<Drawer anchor="right" open={Boolean(open)} onClose={onClose} PaperProps={{
      sx: {
        borderTopLeftRadius: '12px',
        borderBottomLeftRadius: '12px',
        width: {
          sm: '658px',
          xs: '95%'
        }
      }
    }} data-sentry-element="Drawer" data-sentry-source-file="FilterAppointmentsDrawer.tsx">
				<Stack sx={{
        padding: {
          sm: '40px',
          xs: '30px'
        },
        position: 'relative',
        height: '100%'
      }} data-sentry-element="Stack" data-sentry-source-file="FilterAppointmentsDrawer.tsx">
					<Stack direction="row" justifyContent="space-between" mb={2.5} data-sentry-element="Stack" data-sentry-source-file="FilterAppointmentsDrawer.tsx">
						<Typography variant="header3" data-sentry-element="Typography" data-sentry-source-file="FilterAppointmentsDrawer.tsx">{t('filter')}</Typography>
						<ButtonBase onClick={onClose} data-sentry-element="ButtonBase" data-sentry-source-file="FilterAppointmentsDrawer.tsx">
							<CloseIcon data-sentry-element="CloseIcon" data-sentry-source-file="FilterAppointmentsDrawer.tsx" />
						</ButtonBase>
					</Stack>
					<Typography variant="header4" mb={0.75} data-sentry-element="Typography" data-sentry-source-file="FilterAppointmentsDrawer.tsx">
						{t('bestDays')}
					</Typography>
					<Stack direction="row" spacing={1} data-sentry-element="Stack" data-sentry-source-file="FilterAppointmentsDrawer.tsx">
						{days.map(day => <ButtonBase key={day} sx={{
            borderRadius: '8px',
            width: '48px',
            height: '48px',
            border: '1px solid',
            borderColor: tempSelectedDays.includes(day) ? 'primary.main' : 'neutrals.primary'
          }} onClick={() => handleDayClick(day)}>
								<Typography variant="bodyMediumBook" sx={{
              color: 'text.interactive'
            }}>
									{day.slice(0, 1)}
								</Typography>
							</ButtonBase>)}
					</Stack>

					<Typography variant="header4" mt={5} data-sentry-element="Typography" data-sentry-source-file="FilterAppointmentsDrawer.tsx">
						{t('bestTime')}
					</Typography>
					<Stack direction="row" alignItems="center" spacing={2} data-sentry-element="Stack" data-sentry-source-file="FilterAppointmentsDrawer.tsx">
						<ButtonBase onClick={() => setTempTimeOfDay('All')} data-sentry-element="ButtonBase" data-sentry-source-file="FilterAppointmentsDrawer.tsx">
							<Radio checked={tempTimeOfDay === 'All'} data-sentry-element="Radio" data-sentry-source-file="FilterAppointmentsDrawer.tsx" />
							<Typography variant="bodyMediumBook" data-sentry-element="Typography" data-sentry-source-file="FilterAppointmentsDrawer.tsx">{t('all')}</Typography>
						</ButtonBase>
						<ButtonBase onClick={() => setTempTimeOfDay('AM')} data-sentry-element="ButtonBase" data-sentry-source-file="FilterAppointmentsDrawer.tsx">
							<Radio checked={tempTimeOfDay === 'AM'} data-sentry-element="Radio" data-sentry-source-file="FilterAppointmentsDrawer.tsx" />
							<Typography variant="bodyMediumBook" data-sentry-element="Typography" data-sentry-source-file="FilterAppointmentsDrawer.tsx">{t('amTime')}</Typography>
						</ButtonBase>
						<ButtonBase onClick={() => setTempTimeOfDay('PM')} data-sentry-element="ButtonBase" data-sentry-source-file="FilterAppointmentsDrawer.tsx">
							<Radio checked={tempTimeOfDay === 'PM'} data-sentry-element="Radio" data-sentry-source-file="FilterAppointmentsDrawer.tsx" />
							<Typography variant="bodyMediumBook" data-sentry-element="Typography" data-sentry-source-file="FilterAppointmentsDrawer.tsx">{t('pmTime')}</Typography>
						</ButtonBase>
					</Stack>

					<Stack mt="auto" direction="row" spacing={3} justifyContent="flex-end" data-sentry-element="Stack" data-sentry-source-file="FilterAppointmentsDrawer.tsx">
						<Button onClick={() => {
            onClose();
            setTempSelectedDays(selectedDays);
            setTempTimeOfDay(timeOfDay);
          }} data-sentry-element="Button" data-sentry-source-file="FilterAppointmentsDrawer.tsx">
							<Typography variant="bodyMediumBook" sx={{
              color: 'text.interactive'
            }} data-sentry-element="Typography" data-sentry-source-file="FilterAppointmentsDrawer.tsx">
								{t('cancel')}
							</Typography>
						</Button>
						<Button onClick={() => {
            handleApply(tempSelectedDays, tempTimeOfDay);
            onClose();
          }} data-sentry-element="Button" data-sentry-source-file="FilterAppointmentsDrawer.tsx">
							<Typography variant="bodyMediumBook" sx={{
              color: 'text.interactive'
            }} data-sentry-element="Typography" data-sentry-source-file="FilterAppointmentsDrawer.tsx">
								{t('apply')}
							</Typography>
						</Button>
					</Stack>
				</Stack>
			</Drawer>
		</>;
};
export default FilterAppointmentsDrawer;